export type Envelope<T> =
    | { status: 'success'; data: T; message?: string; meta?: Record<string, unknown> }
    | { status: 'fail' | 'error'; message?: string; code?: string | number; errors?: unknown };

export function unwrap<T>(raw: unknown): T {
    if (raw && typeof raw === 'object' && 'status' in (raw as any)) {
        const env = raw as Envelope<T>;
        if (env.status === 'success') return env.data;
        const err = new Error(env.message || 'Request failed');
        (err as any).code = (env as any).code;
        (err as any).details = (env as any).errors;
        throw err;
    }
    return raw as T; // tolerate endpoints not wrapped yet
}
